import { useEffect } from "react";

/**
 * TwoDoneBridge — tiny page loaded inside Two.inc's iframe once the buyer
 * finishes the verification flow. Two.inc redirects the iframe to
 *     /two/done?invoice=...&status=ok|cancel
 * which is same-origin with our app, so we can postMessage out to the parent
 * window (the checkout modal) which closes and refreshes.
 */
export default function TwoDoneBridge() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const invoice = params.get("invoice") || "";
    const status = params.get("status") || "ok"; // "ok" | "cancel"
    const msg = { type: "verqo:two-done", invoice, status };
    // Try to reach the parent frame (modal host). If we're not in a frame
    // (buyer got redirected via top-level nav), fall back to a full-page
    // confirmation with a link back into the portal.
    if (window.parent && window.parent !== window) {
      try {
        window.parent.postMessage(msg, "*");
      } catch {
        /* cross-origin parent — silently ignore */
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-background grid place-items-center p-6">
      <div className="max-w-sm text-center space-y-4" data-testid="two-done-bridge">
        <div className="display text-2xl tracking-tight">All set.</div>
        <p className="text-sm text-foreground/60">
          Your Two.inc authorization is complete. This window will close automatically.
        </p>
        <a href="/buyer/payments" className="inline-block text-xs mono text-foreground/60 hover:text-foreground">
          Return to Payments →
        </a>
      </div>
    </div>
  );
}
